import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
// Thunk: Delete user by ID
export const deletuser = createAsyncThunk(
  "levels/deleteuser",
  async (profile_id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${apiUrl}/Profile/${profile_id}/Delete/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return profile_id; // Return the ID of the deleted user
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed to delete user"
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: [], // Store for all user
    deleteStatus: "idle", // Status for delete operation
    deleteError: null, // Error for delete operation
  },
  reducers: {
    resetDeleteStatus: (state) => {
      state.deleteStatus = "idle";
      state.deleteError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle deletuser action
      .addCase(deletuser.pending, (state) => {
        state.deleteStatus = "loading";
        state.deleteError = null;
      })
      .addCase(deletuser.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.levels = state.levels.filter((level) => level.id !== action.payload);
      })
      .addCase(deletuser.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.deleteError = action.payload;
      });
  },
});

export const { resetDeleteStatus } = userSlice.actions;

export default userSlice.reducer;
